import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { salesDataDomainStore } from '../../store';
export const getSellableItemForSiteByHopk = (siteId, hopk) => { var _a; return getFetchedDataPayload((_a = salesDataDomainStore.data.sellableItemsForSiteByHopk[siteId]) === null || _a === void 0 ? void 0 : _a[hopk]); };
